import { ClientFileApi } from "@shared";

import {
  assetInventoryDocumentsApi,
  bankruptcyChecklistApi,
  claimsApi,
  clientNoteApi,
  clientsApi,
  proceedingParticipantsApi,
  settingsApi,
  systemDropdownsApi,
  viennaAddressesApi,
} from "@/api";
import { documentDndSlice } from "@/common/components/layout/components/dropzone/dnd/documentDndSlice";

// Adapts this app's generated api-client singletons to the @shared ClientFileApi seam (shared code
// cannot import a generated client). The generated classes satisfy the restated slice interfaces
// structurally. Slices grow alongside each lifted client-file area.
export const clientFileApi: ClientFileApi = {
  bankruptcyChecklist: bankruptcyChecklistApi,
  assetInventory: clientsApi,
  assetInventoryDocuments: assetInventoryDocumentsApi,
  documentDnd: documentDndSlice,
  lookups: {
    getAllDropdownOptions: () => settingsApi.getAllDropdownOptions(),
    getSystemDropdownOptions: (params) => systemDropdownsApi.getSystemDropdownOptions(params),
    searchViennaAddresses: (params) => viennaAddressesApi.searchViennaAddresses(params),
  },
  claims: claimsApi,
  clientNote: clientNoteApi,
  // The neutral participant methods carry a `clientId` for the portal's client-scoped routes; internally
  // the search route already takes `clientId` as a query param and the by-id route ignores it.
  participants: {
    searchParticipants: (params) =>
      proceedingParticipantsApi.searchProceedingParticipants({
        searchText: params.searchText,
        clientId: params.clientId,
        includeInactive: params.includeInactive,
        types: params.types,
      }),
    getParticipantById: (params) =>
      proceedingParticipantsApi.getProceedingParticipantById({ participantId: params.participantId }),
    createClientSpecificParticipant: (params) =>
      proceedingParticipantsApi.createClientSpecificProceedingParticipant(params),
    updateClientSpecificParticipant: (params) =>
      proceedingParticipantsApi.updateClientSpecificProceedingParticipant(params),
  },
};
